import cn from 'classnames';

export const tableTitleFilterWrapperClassName = ({ filter }: { filter?: boolean }) =>
  cn(filter && 'cursor-pointer hover:bg-bg_4');

export const tableColumnClassName =
  'text-black text-[12px] font-[600] w-full duration-150 ease-in-out select-none';
